<c11n-nav-overflow
  class="d-block d-lg-none"
  [menuData]="navigationMenu"
  [triggerLabel]="'Actions'"
  [direction]="'below'"
  (selectItemEvent)="onMessageNavigationMenu($event)"
  [externalLabel]="true">
</c11n-nav-overflow>
